var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 4.25H3.75C3.05965 4.25 2.5 4.80965 2.5 5.5V25.5C2.5 26.1904 3.05965 26.75 3.75 26.75H26.25C26.9404 26.75 27.5 26.1904 27.5 25.5V5.5C27.5 4.80965 26.9404 4.25 26.25 4.25ZM15 20.5C12.9289 20.5 11.25 18.8211 11.25 16.75H5V6.75H25V16.75H18.75C18.75 18.8211 17.0711 20.5 15 20.5ZM20 14.25H16.25V18H13.75V14.25H10L15 8.625L20 14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFill);
export default __webpack_public_path__ + "static/media/export-fill.7196fba459ea4baf4d2788e175e7dd72.svg";
export { ForwardRef as ReactComponent };